import { jsx } from 'react/jsx-runtime';
import { useReferenceSafeObject } from '@flex-design-system/fx-utils';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getColor } from '../../../../utils/colors.mjs';
import { Typography } from '../../../typography/Typography.mjs';
import { useTagContext } from '../../context.mjs';
import { tagText, tagTextColor } from './text.vanilla.mjs';

const TAG_TEXT_SIZE_RECORD = {
  small: 10,
  default: 11,
  large: 12
};
const TAG_TEXT_LINE_HEIGHT_RECORD = {
  small: "16px",
  default: "19px",
  large: "24px"
};
const TagText = forwardRef(
  ({
    color,
    className: classNameFromProps,
    size: sizeFromProps,
    lineHeight: lineHeightFromProps,
    style: styleFromProps,
    ...props
  }, forwardedRef) => {
    const { size } = useTagContext("Tag.Text");
    const style = useReferenceSafeObject(styleFromProps);
    const className = classNames(tagText, classNameFromProps);
    const styles = Object.assign(
      {},
      assignInlineVars({
        [tagTextColor]: color !== void 0 ? getColor(color) : null
      }),
      style
    );
    return /* @__PURE__ */ jsx(
      Typography,
      {
        "data-scope": "tag",
        "data-part": "text",
        className,
        style: styles,
        size: sizeFromProps ?? TAG_TEXT_SIZE_RECORD[size],
        lineHeight: lineHeightFromProps ?? TAG_TEXT_LINE_HEIGHT_RECORD[size],
        ref: forwardedRef,
        ...props
      }
    );
  }
);
TagText.displayName = "TagText";

export { TagText };
//# sourceMappingURL=Text.mjs.map
